module.exports = __webpack_public_path__ + "static/assets/47144cdb9c8e168e8013458020a28448.png";